import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { OAuthApplicationFieldsFragmentDoc } from './load-oauth-applications.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateOauthApplicationMutationVariables = Types.Exact<{
  attributes: Types.OauthApplicationInput;
}>;


export type CreateOauthApplicationMutation = { __typename?: 'Mutation', createOauthApplication?: { __typename?: 'CreateOauthApplicationPayload', successful: boolean, oauthApplication?: { __typename?: 'OAuthApplication', id: string, uid: string, name: string, secret: string, redirectUri: string } | null, validations?: { __typename?: 'ValidationsOauthApplication', name?: Array<{ __typename?: 'ValidationsMessage', message: string, severity: Types.ValidationsSeverity }> | null, redirectUri?: Array<{ __typename?: 'ValidationsMessage', message: string, severity: Types.ValidationsSeverity }> | null } | null } | null };

export const CreateOauthApplicationDocument = gql`
    mutation CreateOauthApplication($attributes: OauthApplicationInput!) {
  createOauthApplication(attributes: $attributes) {
    oauthApplication {
      ...OAuthApplicationFields
    }
    successful
    validations {
      name {
        message
        severity
      }
      redirectUri {
        message
        severity
      }
    }
  }
}
    ${OAuthApplicationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOauthApplicationGQL extends Apollo.Mutation<CreateOauthApplicationMutation, CreateOauthApplicationMutationVariables> {
    document = CreateOauthApplicationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }